/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GreyfinchComplete/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import GreyfinchBird from 'DesignSystem/Svgs/GreyfinchBird/index'
import MedicalForm from './MedicalForm/index'
import NextAction from './NextAction/index'
import React from 'react'
import Thanks from './Thanks/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function GreyfinchComplete({
  children,
  viewPath = "/App/Widget/Content/Questions/GreyfinchComplete",
  title,
  goTo,
  subtitle
  
}) {
  let isBefore = useIsBefore()
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let authAccessTokenDataLeadIdValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.lead_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let widgetSettingsMedicalformenabledValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'settings.medicalFormEnabled',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let widgetHasBookingValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'hasBooking',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  title,
  goTo,
  subtitle
  
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="GreyfinchComplete.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Z197J3x': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="GreyfinchComplete.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="GreyfinchComplete.Horizontal"
  data-view-path={viewPath}
 style={{'--bblr-2-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-6-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-7-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="GreyfinchComplete.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="auth.access_token_data.lead_id"
 text={authAccessTokenDataLeadIdValueData}
 color="white"
 fontSize={1}
 className="patientUuid"
 className="patientUuid"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 textAlign="center"
 text={title}
 hyphens="none"
/>
</div>
</div>
<Thanks
  viewPath={`${viewPath}/Thanks`}
/>
<NextAction
  viewPath={`${viewPath}/NextAction`}
 goTo={goTo}
/>
<div
  data-testid="GreyfinchComplete.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bblr-2-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-6-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-7-Z197J3x': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 marginTop={20}
 size="small"
 text={subtitle}
 hyphens="none"
/>
</div>
<fromFlow.When is={widgetSettingsMedicalformenabledValueData}>
<div
  data-testid="GreyfinchComplete.Vertical:3"
  data-view-path={viewPath}
 style={{'--bblr-2-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-6-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-8-Z197J3x': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-9-Z197J3x': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical3}`}
>
<MedicalForm
  viewPath={`${viewPath}/MedicalForm`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 size="large"
 paddingLeft={20}
 paddingRight={20}
 text="Please check your email and fill out your medical history form before the day of your appointment."
/>
<fromFlow.When is={widgetHasBookingValueData}>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 data="widget.hasBooking"
 marginTop={dtSpaceL}
 size="large"
 textAlign="center"
 color="#0093c9"
 text="Start over"
 onClick={onClick}
/>
</fromFlow.When>
</div>
</fromFlow.When>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 size="large"
 marginTop={dtSpaceM}
 text="If you have any problems please contact the practice directly."
 hyphens="none"
/>
</div>
<div
  data-testid="GreyfinchComplete.Logo"
  data-view-path={viewPath}
 style={{'--pl-8-Z197J3x': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-9-Z197J3x': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z197J3x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Logo}`}
>
<GreyfinchBird
  viewPath={`${viewPath}/GreyfinchBird`}
 height={42}
 width={42}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color="#858585"
 size="small"
 weight="light"
 text="Powered By Greyfinch"
/>
</div>
</div>
{children}
</React.Fragment>)
}